import React from "react";
import "./WhatsIncluded.css";
import { CmsText } from "../../../../RichTextContent/RichTextContent";
import { useServiceSection } from "../../../../../context/ServicePageContext";
import { getListItemsFromSection } from "../../../../../services/contentApi";
import checkIcon from "../../../../../assets/images/checkCircle.png";

const WhatsIncluded = () => {
  const { section, loading } = useServiceSection("whats-included");

  if (loading || !section?.fields) return null;

  const fields = section.fields;
  const items = getListItemsFromSection(section);
  const midpoint = Math.ceil(items.length / 2);
  const leftColumn = items.slice(0, midpoint);
  const rightColumn = items.slice(midpoint);

  return (
    <section className="included">
      <div className="included__container">
        {fields.label ? (
          <CmsText
            content={fields.label}
            as="span"
            className="included__label"
          />
        ) : null}

        {fields.title ? (
          <CmsText content={fields.title} as="h2" />
        ) : null}

        {fields.subtitle ? (
          <CmsText
            content={fields.subtitle}
            as="p"
            className="included__subtitle"
          />
        ) : null}

        <div className="included__grid">
          <div className="included__column">
            {leftColumn.map((item, i) => (
              <div className="included__item" key={i}>
                <img src={checkIcon} alt="" />
                <CmsText content={item} as="span" />
              </div>
            ))}
          </div>

          <div className="included__column">
            {rightColumn.map((item, i) => (
              <div className="included__item" key={i}>
                <img src={checkIcon} alt="" />
                <CmsText content={item} as="span" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhatsIncluded;
